import { render, staticRenderFns } from "./ChartVCs.vue?vue&type=template&id=00afcb0a&"
import script from "./ChartVCs.vue?vue&type=script&lang=ts&"
export * from "./ChartVCs.vue?vue&type=script&lang=ts&"
import style0 from "./ChartVCs.vue?vue&type=style&index=0&id=00afcb0a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports